import { useNavigate } from 'react-router-dom';

const BackButton = () => {
    const navigate = useNavigate();

    return (
        <div
            className="flex items-center ml-2 text-sm cursor-pointer w-fit mb-8"
            onClick={() => navigate(-1)}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="14 18 8 12 14 6" />
            </svg>
            Back
        </div>
    );
};

export default BackButton;
